import { useState, useRef, useCallback, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const useRecaptcha = () => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const handleRecaptcha = useCallback((token) => {
    setCaptchaToken(token);
  }, []);

  useEffect(() => {
    const refreshCaptcha = () => {
      if (recaptchaRef.current && captchaToken) {
        if (typeof recaptchaRef.current.reset === 'function') {
          recaptchaRef.current.reset();
        }
        setCaptchaToken(null);
      }
    };

    let tokenRefreshTimeout = null;

    if (captchaToken) {
      // Reset 10 seconds before the 2-minute expiration
      tokenRefreshTimeout = setTimeout(refreshCaptcha, 110000);
    }

    return () => {
      if (tokenRefreshTimeout) clearTimeout(tokenRefreshTimeout);
    };
  }, [captchaToken]);

  return { captchaToken, setCaptchaToken, recaptchaRef, handleRecaptcha };
};

export default useRecaptcha;